/* eslint-disable func-names */
// import '@zr/common/js/jquery-plugins/jquery.hoverIntent'; // TODO

/**
 * Desktop version.
 */
const openDropdown = ($el) => {
  $el.closest('[data-header-nav-section]').addClass('expanded_desktop');
  $el.prop('aria-expanded', 'true');
};
const closeDropdown = ($el) => {
  $el.closest('[data-header-nav-section]').removeClass('expanded_desktop');
  $el.prop('aria-expanded', 'false');
};

$(document).on('focusin', '[data-header-nav-section]', function () {
  openDropdown($(this));
});

$(document).on('focusout', '[data-header-nav-section]', function (e) {
  // Don't close if we're just focusing on another element within this element.
  if (!$(e.relatedTarget).closest($(this)).length) {
    closeDropdown($(this));
  }
});

$(document).on('mouseover', '[data-header-nav-section]', function () {
  openDropdown($(this));
});

$(document).on('mouseout', '[data-header-nav-section]', function () {
  closeDropdown($(this));
});


/**
 * Mobile version.
 *
 * TODO: We need to eventually migrate app/view/themes/light/common/_header_logged_out_global__mobile_nav_mc-3358.html and use that on mobile.
 *       That header is a nicer mobile header that we will want to use on other pages.
 *       For now we are using the simpler mobile header based on the version in app/view/themes/light/common/_header_logged_out_global_nav_277177.html
 */

// Mobile.
$(document).on('click', '[data-header-nav-section-toggle]', function () {
  // Toggle the dropdown open.
  const $this = $(this);
  const $menu = $this.closest('[data-header-nav-section]');
  $menu.toggleClass('expanded_mobile');
  $this.prop('aria-expanded', $this.prop('aria-expanded') === 'true' ? 'false' : 'true');
});

$(document).on('click', '[data-header-nav-toggle]', function () {
  const $this = $(this);
  $this.prop('aria-expanded', $this.prop('aria-expanded') === 'true' ? 'false' : 'true');
  $this.toggleClass('active');
  $('[data-header-nav]').toggleClass('expanded');
});
